module.exports = __webpack_public_path__ + "img/7.a1713b35.jpg";